<template>
	<p>Copyright © 2017-2019 驿车驹 All Rights Reserved.</p>
</template>

<script>
export default {
  name: "copyright",
  data() {
    return {
    };
  },
  created() {},
  mounted() {},
  methods: {
  }
};
</script>
<style scoped>
	
</style>



// WEBPACK FOOTER //
// src/page/components/copyright.vue